import React from 'react';
import { routesUrl } from '../../../fuse-configs/navigationConfig';

const DemoAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.demoAnalytics,
      component: React.lazy(() => import('./AnalyticsDemo')),
    },
    {
      path: routesUrl.demoLoyalties,
      component: React.lazy(() => import('./AnalyticsDemo')),
    },
    {
      path: routesUrl.demoClients,
      component: React.lazy(() => import('./AnalyticsDemo')),
    },
  ],
};

export default DemoAppConfig;
